import React from 'react';
import ReportNavigationLink from '../../wizard/common/components/ReportNavigationLink';

export default {
  total: ({ column, data }, totalHeader) => { // eslint-disable-line react/prop-types
    const { report } = column.parentColumn.drillDownLink;
    const value = typeof totalHeader === 'function'
      ? totalHeader({ column, data })
      : totalHeader;
    return <ReportNavigationLink report={report.id}>{value}</ReportNavigationLink>;
  },
  cell: (row, fieldFormatter) => {
    const { column, row: fullRow } = row;
    const value = fieldFormatter ? fieldFormatter(row) : row.value;
    const { report, dateField } = column.parentColumn.drillDownLink;
    const date = fullRow[dateField];
    return (
      <ReportNavigationLink report={report.id} date={date}>
        {value}
      </ReportNavigationLink>);
  },
};
